<template>
    <main style="overflow-x:hidden;">
        <TopSection></TopSection>
        <Real></Real>
        <Gallery></Gallery>
        <HowWeWork></HowWeWork>
    </main>
</template>

<script>
import TopSection from './Painting/TopSection.vue';
import Real from './Painting/Real.vue';
import Gallery from './Painting/Gallery.vue';
import HowWeWork from './Painting/HowWeWork.vue';
export default {
    name: "home-painting",
    components: { TopSection, Real, Gallery, HowWeWork }
}
</script>